import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7c628192")

_pushScopeId("data-v-7c628192")
const _hoisted_1 = { class: "pw-player-playBtn-holder player-adon" }
const _hoisted_2 = /*#__PURE__*/_createVNode("svg", {
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "#fff"
}, [
  /*#__PURE__*/_createVNode("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createVNode("g", {
      transform: "translate(1 1)",
      "stroke-width": "2"
    }, [
      /*#__PURE__*/_createVNode("circle", {
        "stroke-opacity": ".5",
        cx: "18",
        cy: "18",
        r: "18"
      }),
      /*#__PURE__*/_createVNode("path", { d: "M36 18c0-9.94-8.06-18-18-18" }, [
        /*#__PURE__*/_createVNode("animateTransform", {
          attributeName: "transform",
          type: "rotate",
          from: "0 18 18",
          to: "360 18 18",
          dur: "1s",
          repeatCount: "indefinite"
        })
      ])
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
})